import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";

class businesstransactionForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                   role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(businesstransactionForm);
